<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001687') }}</span>
				</div>
			</div>

			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!--고객불만내용-->
							<th class="col-1">* {{ getMessage_('QWCC001078') }}</th>
							<td class="col-9">
								<el-input v-model="custCplnSbc" maxlength="330" :readonly="pwaApcnPopUp.readOnlyAuth" />
							</td>
						</tr>
						<tr>
							<!--기술진단-->
							<th class="col-1">* {{ getMessage_('QWCC001079') }}</th>
							<td class="col-9">
								<el-input v-model="tclgDgns" maxlength="330" :readonly="pwaApcnPopUp.readOnlyAuth" />
							</td>
						</tr>

						<tr>
							<!--상세내용-->
							<th class="col-1">* {{ getMessage_('QWCC001080') }}</th>
							<td class="col-9">
								<el-input v-model="dtlSbc" maxlength="330" :readonly="pwaApcnPopUp.readOnlyAuth" />
							</td>
						</tr>
						<tr>
							<!--건의사항-->
							<th class="col-1">{{ getMessage_('QWCC001081') }}</th>
							<td class="col-9">
								<el-input v-model="sgtn" maxlength="330" :readonly="pwaApcnPopUp.readOnlyAuth" />
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';
import { convertNvl } from '@/qmsUtils/'; //공통함수 import

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {},
	data() {
		return {
			custCplnSbc: '', // excel-file-input 초기화여부
			tclgDgns: '',
			dtlSbc: '',
			sgtn: ''
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		chgFlag() {
			return this.getIsSaveFlag_;
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		setProcessInfo() {
			//스토어에서 값을 가져와서 셋팅한다.

			this.custCplnSbc = this.pwaApcnPopUp.custCplnSbc; // PWANO
			this.tclgDgns = this.pwaApcnPopUp.tclgDgns; //처리단계코드
			this.dtlSbc = this.pwaApcnPopUp.dtlSbc; // 처리단계명
			this.sgtn = this.pwaApcnPopUp.sgtn; //신청일
		}
	},
	async created() {
		//스토어에서 값을 가져와서 셋팅한다.
		this.custCplnSbc = this.pwaApcnPopUp.custCplnSbc; // PWANO
		this.tclgDgns = this.pwaApcnPopUp.tclgDgns; //처리단계코드
		this.dtlSbc = this.pwaApcnPopUp.dtlSbc; // 처리단계명
		this.sgtn = this.pwaApcnPopUp.sgtn; //신청일
	},
	watch: {
		chgFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.getIsSaveFlag_) {
				this.setStateApcnSave_({ key: 'custCplnSbc', value: convertNvl(this.custCplnSbc, '') }); // PWANO
				this.setStateApcnSave_({ key: 'tclgDgns', value: convertNvl(this.tclgDgns, '') }); //처리단계코드
				this.setStateApcnSave_({ key: 'dtlSbc', value: convertNvl(this.dtlSbc, '') }); // 처리단계명
				this.setStateApcnSave_({ key: 'sgtn', value: convertNvl(this.sgtn, '') }); //신청일
			}
		}
	}
};
</script>
<style></style>
